import { addDaysInTimezone, setTimeOfDateInTimezone } from "@performyard/utils-isomorphic";

/**
 * Compute a relative due date, mirroring the backend (`generate-form-assignments.ts`):
 * add `daysToAdd` days to the start date, then set the time to the provided company's default
 * due time - both in the company timezone.
 */
export const computeRelativeDueDate = ({
	startDate,
	daysToAdd,
	defaultDueTime,
	companyTimezone,
}: {
	startDate: Date;
	daysToAdd: number;
	defaultDueTime: number;
	companyTimezone: string;
}): Date => {
	const shiftedUtc = addDaysInTimezone({ date: startDate, days: daysToAdd, timezone: companyTimezone });
	return setTimeOfDateInTimezone({ date: shiftedUtc, hours: defaultDueTime, timezone: companyTimezone });
};
